import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiGet, apiPut } from './api';
import {
  IGroupedMentionsResponse,
  IBulkUpdateMentionsDto,
  IUpdateMentionDto
} from '../types/dashboard.types';
const { REACT_APP_SUBSCRIPTION } = process.env;

/**
 * Obtiene las menciones de un usuario específico. El id es obtenido en backend usando el token de autenticación.
 * @returns Promise con las menciones del usuario
 */
export const getUserMentions = async (): Promise<IGroupedMentionsResponse> => {
  return apiGet<AxiosRequestConfig, IGroupedMentionsResponse>(
    `${REACT_APP_SUBSCRIPTION}/mentions/was-mentioned`
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const updateMention = async (mentionId: number, updateMentionDto: IUpdateMentionDto): Promise<void> => {
  return apiPut<AxiosRequestConfig, IUpdateMentionDto>(
    `${REACT_APP_SUBSCRIPTION}/mentions/${mentionId}`,
    updateMentionDto
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const updateAllMentions = async (updateMentionsDto: IBulkUpdateMentionsDto): Promise<void> => {
  return apiPut<AxiosRequestConfig, IBulkUpdateMentionsDto>(
    `${REACT_APP_SUBSCRIPTION}/mentions/bulk`,
    updateMentionsDto
  )
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};
